import React from "react";

const LoadingScreen = () => {
  return (
    <div
      style={{
        height: "100vh",
        width: "100vw",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#ebefe6",
        color: "#020817",
        fontSize: "1.4rem",
        letterSpacing: "0.8px",
      }}
    >
      <div className="loader-wrapper" style={{ textAlign: "center" }}>
        <div
          className="spinner"
          style={{
            width: "48px",
            height: "48px",
            border: "4px solid rgba(2, 8, 23, 0.2)",
            borderTopColor: "#020817",
            borderRadius: "50%",
            animation: "spin 0.8s linear infinite",
            margin: "0 auto 18px",
          }}
        />
        Loading...
      </div>

      <style>
        {`@keyframes spin {
            to { transform: rotate(360deg); }
        }`}
      </style>
    </div>
  );
};

export default LoadingScreen;
